import { api } from "./client";

export type InseratStatus =
  | "neu"
  | "shortlist"
  | "dismissed"
  | "in-analyse"
  | "gekauft"
  | "expired";

export interface Adresse {
  plz: string | null;
  ort: string | null;
  strasse: string | null;
  bundesland: string | null;
}

export interface Inserat {
  /** Stable dedup key — use as path param for status/analyse mutations. */
  key: string;
  quelle: string;
  portal: string;
  source_url: string;
  listing_id: string | null;
  title: string | null;
  objekt_typ: string | null;
  kaufpreis_eur: number | null;
  wohnflaeche_m2: number | null;
  grundstuecksflaeche_m2: number | null;
  zimmer: number | null;
  baujahr: number | null;
  energie_klasse: string | null;
  energie_kennwert_kwh_m2_a: number | null;
  heizungs_typ: string | null;
  kaltmiete_ist_eur: number | null;
  hausgeld_eur: number | null;
  adresse: Adresse;
  status: InseratStatus;
  score: number | null;
  hard_criteria_pass: boolean | null;
  hard_criteria_failed: string[];
  soft_criteria_breakdown: Record<string, number>;
  rote_flaggen: string[];
  erste_sichtung_at: string;
  letzte_aktualisierung_at: string;
}

export interface InserateListResponse {
  inserate: Inserat[];
  total: number;
}

export interface ListInserateParams {
  status_filter?: InseratStatus;
  quelle?: string;
  limit?: number;
}

export async function listInserate(
  params: ListInserateParams = {},
): Promise<InserateListResponse> {
  const { data } = await api.get<InserateListResponse>("/api/inserate", {
    params,
  });
  return data;
}

export async function setInseratStatus(
  key: string,
  status: InseratStatus,
  notes?: string,
): Promise<{ key: string; status: InseratStatus; notes: string | null }> {
  const { data } = await api.post(`/api/inserate/${encodeURIComponent(key)}/status`, {
    status,
    notes: notes ?? null,
  });
  return data;
}

export interface AnalyseResponse {
  key: string;
  slug: string;
  objekt_dir: string;
  is_new: boolean;
  kaufpreis_eur: number | null;
  wohnflaeche_m2: number | null;
}

export async function analyseInserat(
  key: string,
  source_url: string,
): Promise<AnalyseResponse> {
  const { data } = await api.post<AnalyseResponse>(
    `/api/inserate/${encodeURIComponent(key)}/analyse`,
    { source_url },
  );
  return data;
}
